<!-- TabComponent.vue -->
<template>
  <div style="display: table;" class="bg-primaryBg rounded-[6px] border border-[#F2F4F7]">
    <div class="flex gap-2 py-1 px-1 text-[14px]">
      <p 
        v-for="tab in tabs" 
        :key="tab" 
        :class="[
          'flex items-center cursor-pointer rounded-[6px] px-4 py-2 whitespace-nowrap ',
          modelValue === tab ? 'bg-[#FFFFFF] text-[#344054] shadow-sm font-bold' : 'text-grayDark'
        ]"
        @click="selectTab(tab)"
      >
        {{ tab }}
      </p>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'TabComponent',
    props: {
      // The tabs to display
      tabs: {
        type: Array,
        required: true
      },
      // v-model for the selected tab
      modelValue: {
        type: String,
        required: true
      },
      // Whether to use compact mode (narrow width) or not
      compact: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      selectTab(tab) {
        this.$emit('update:modelValue', tab);
      }
    }
  };
  </script>